import React from 'react'
import { Button, Text, TextVariant, Wallet } from '@mprolab/uikit'
import { useConnectPanel } from 'contexts/ConnectPanel'

interface UserPanelButtonProps {
  title?: string
}

const UserPanelButton: React.FC<UserPanelButtonProps> = ({ title }) => {
  const { setConnectPanelOpen, connectPanelDisabled } = useConnectPanel()

  return (
    <Button endIcon={<Wallet />} size="sm" disabled={connectPanelDisabled} onClick={() => setConnectPanelOpen(true)}>
      {title && (
        <Text variant={TextVariant.BODY_SMALL_BOLD} clickable>
          {title}
        </Text>
      )}
    </Button>
  )
}

export default UserPanelButton
